<div
  class="row item-row"
  [ngClass]="{
    'single-item-row': isSingleItem,
    'card-radio-icon': isSingleItem && imageClassFromFrontEnd,
    'card-radio-image': isSingleItem && image,
    'multiple-items-row': !isSingleItem,
    'isLast': isLast,
    'isFirst': isFirst,
    'disabled': disabled,
    'item-row-hover': !checked
  }"
  [class.selected]="checked"
  (click)="onClickSelector()"
>
  <div class="row d-flex flex-row align-items-center flex-nowrap">
    <span
      *ngIf="image"
      class="d-inline-block cursor-pointer image-span"
    >
      <img
        [src]="image"
        class="selector-image m-w-image cursor-pointer"
      />
    </span>
    <span
      *ngIf="imageClassFromFrontEnd"
      class="card-icon bticino-ico {{imageClassFromFrontEnd}} cursor-pointer"
    ></span>
    
    <div>
      <h5 *ngIf="!showNameUnderDescription">{{ name | translate }}</h5>
      <p *ngIf="showDescription" class="item-description" [class.before-name]="showNameUnderDescription">{{description}}</p>
      <p class="h7" *ngIf="showNameUnderDescription">{{ name | translate }}</p>
    </div>
  </div>
  <div *ngIf="!!tooltipType" class="tooltip-container d-flex justify-content-between">
    <button
        mat-flat-button
        *ngIf="infoTooltipIsVisible(tooltipType)"
        class="bticino-ico info round-button-with-background d-inline-block m-l-info min-w-fit-content"
        (click)="onInfoClick($event)"
      >
    </button>
    <button
      mat-button
      class="tooltipText"
      color="accent"
      *ngIf="discoverTooltipIsVisible(tooltipType)"
      (click)="onInfoClick($event)" (mouseover)="isHoveringIco=true" (mouseout)="isHoveringIco=false"
    >
      <span class="bticino-ico cursor-pointer discover-button"
      [ngClass]="{'ico-play-hover': isHoveringIco,'ico-play': !isHoveringIco}"
      ></span>
      {{'b2c.IDS_DISCOVER' | translate}}
    </button>
    <button
      mat-button
      color="accent"
      *ngIf="selectTooltipIsVisible(tooltipType)"
      class="select-button"
    >{{'b2c.IDS_SELECT' | translate}}
    </button>
    <div *ngIf="disabled && selected" class="included-label h7">{{'b2c.IDS_INCLUDED' | translate}}</div>
  </div>
</div>
